'use client';
import { SPACING_3 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

export const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING_3};
`;
